// utils/formatters.js
export const formatNumber = (num, decimals = 2) => {
    if (!num || isNaN(Number(num))) return "0";
    
    const number = Number(num);
    
    // Format large numbers with abbreviations (K, M, B)
    if (number >= 1000000000) {
      return (number / 1000000000).toFixed(decimals) + 'B';
    }
    if (number >= 1000000) {
      return (number / 1000000).toFixed(decimals) + 'M';
    }
    if (number >= 1000) {
      return (number / 1000).toFixed(decimals) + 'K';
    }
    
    return number.toLocaleString('en-US', {
      maximumFractionDigits: decimals,
      minimumFractionDigits: 0
    });
  };
  
  export const formatAddress = (address, startChars = 6, endChars = 4) => {
    if (!address) return "";
    return `${address.substring(0, startChars)}...${address.substring(address.length - endChars)}`;
  };
  
  export const formatBalance = (balance, decimals = 4) => {
    if (!balance || isNaN(Number(balance))) return "0";
    return Number(balance).toLocaleString('en-US', {
      maximumFractionDigits: decimals,
      minimumFractionDigits: 0
    });
  };

  export const formatPrice = (price) => {
    if (!price || isNaN(price) || parseFloat(price) === 0) return "0.0000";
    const num = typeof price === 'string' ? parseFloat(price) : price;
    
    if (num < 0.000001) {
      return num.toExponential(4);
    } else if (num < 0.001) {
      return num.toFixed(8);
    } else if (num < 1) {
      return num.toFixed(6);
    } else {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4
      });
    }
  };